module.exports = __webpack_public_path__ + "static/media/ic-accept-hover.4f8b3d67.svg";